import { QUESTIONS, QUESTION_COUNT_PER_ARCHETYPE } from '../data/questions';
import { ARCHETYPE_ORDER } from '../data/types';
import type { Answers, Archetype, Scores } from '../data/types';

/**
 * Per-archetype score, normalized to 0..100.
 * Raw range per archetype = 4 (all 1s) to 20 (all 5s); we map to 0..100.
 */
export function computeScores(answers: Answers): Scores {
  const raw: Scores = {
    servant: 0,
    devotee: 0,
    sensualist: 0,
    primal: 0,
    brat: 0,
    little: 0,
  };
  const counts: Scores = {
    servant: 0,
    devotee: 0,
    sensualist: 0,
    primal: 0,
    brat: 0,
    little: 0,
  };

  for (const q of QUESTIONS) {
    const a = answers[q.id];
    if (a == null) continue;
    raw[q.archetype] += a;
    counts[q.archetype] += 1;
  }

  const scores = { ...raw };
  for (const arc of ARCHETYPE_ORDER) {
    const expected = QUESTION_COUNT_PER_ARCHETYPE;
    // If the user answered every question, raw is 4..20 → normalize to 0..100.
    // If partial, scale by what they did answer (still 0..100).
    const c = counts[arc] || 1;
    const max = c * 5;
    const min = c * 1;
    const range = max - min || 1;
    const pct = ((raw[arc] - min) / range) * 100;
    scores[arc] = Math.max(0, Math.min(100, Math.round(pct)));
    void expected; // we may use this later for partial-answer weighting
  }

  return scores;
}

export function topArchetypes(scores: Scores, threshold = 40): Archetype[] {
  return [...ARCHETYPE_ORDER]
    .filter((a) => scores[a] >= threshold)
    .sort((a, b) => scores[b] - scores[a]);
}

export function rankedArchetypes(scores: Scores): Archetype[] {
  return [...ARCHETYPE_ORDER].sort((a, b) => scores[b] - scores[a]);
}
